module.exports = __webpack_public_path__ + "img/06_tu.40c36713.png";